module.exports = __webpack_public_path__ + "media/images/brands/marque-schwarzkopf@2x-e121db1ab4f3ef88f8c72a851367cf1e.jpg";